import { Suspense, lazy } from 'react';
import type { StepT } from './types';

const MultipleChoiceStep = lazy(() => import('./MultipleChoiceStep'));
const CalendarStep = lazy(() => import('./calendarStep/CalendarStep'));
const StudyPanel = lazy(() => import('./studyPanel/StudyPanel'));
const CheckboxStep = lazy(() => import('./CheckboxStep'));

type Props = {
    step: StepT;
    answerStep: (v: StepT) => Promise<void>;
};

export const Step = ({ step, answerStep }: Props) => {
    if (!step?.type) return null;

    if (step.type === 'statement' || step.type === 'multipleChoice') {
        return (
            <Suspense fallback={<div />}>
                <MultipleChoiceStep step={step} answerStep={answerStep} />
            </Suspense>
        );
    }
    if (step.type === 'checkboxes') {
        return (
            <Suspense fallback={<div />}>
                <CheckboxStep step={step} answerStep={answerStep} />
            </Suspense>
        );
    }
    if (step.type === 'studyPanel') {
        return (
            <Suspense fallback={<div />}>
                <StudyPanel step={step} answerStep={answerStep} />
            </Suspense>
        );
    }
    if (step.type === 'calendarStep') {
        return (
            <Suspense fallback={<div />}>
                <CalendarStep step={step} answerStep={answerStep} />
            </Suspense>
        );
    }
    return <div />;
};
